const integrations = {
  backToIntegrations: 'Integrations',
  enabled: 'ENABLED',
  outOfService: 'Coming Soon...',
  enable: 'Enable',
  updateIntegration: 'Update',
  app: {
    actions: {
      disable: {
        button: 'Disable',
        success: 'Integration successfully disabled',
        failure: 'An error occurred disabling the integration',
        confirmModal: {
          header: 'Confirm Integration Disconnection',
          body: 'To disable the integration, enter the word \'disable\' into the text field and confirm.',
          verificationPhrase: 'disable',
        },
      },
      oneTwoWayVerificationModal: {
        toOneWayInstructions: 'To change the integration to 1-way, enter the word \'change\' into the text field and confirm.',
        toTwoWayInstructions: 'To change the integration to 2-way, enter the word \'change\' into the text field and confirm.',
        verificationPhrase: 'change',
      },
      submit: {
        success: 'Custom action successfully initiated',
        failure: 'An error occurred while initiating custom action',
      },
    },
  },
  form: {
    submit: {
      enable: {
        success: 'Integration successfully activated. Custom actions have been initiated...',
        failure: 'Unable to enable integration. Check your auth configuration',
      },
    },
  },
  categories: {
    all: 'All',
    communications: 'Communications',
    dispatch: 'Dispatch',
    finance: 'Finance',
    vehicleIntegration: 'Vehicle Integration',
  }
};

export default integrations;
